"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _ValidationError = _interopRequireDefault(require("./ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The ValidationErrorResponse model module.
 * @module model/ValidationErrorResponse
 * @version 1.0.0
 */
var ValidationErrorResponse = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ValidationErrorResponse</code>.
   * @alias module:model/ValidationErrorResponse
   */
  function ValidationErrorResponse() {
    _classCallCheck(this, ValidationErrorResponse);

    ValidationErrorResponse.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(ValidationErrorResponse, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>ValidationErrorResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ValidationErrorResponse} obj Optional instance to populate.
     * @return {module:model/ValidationErrorResponse} The populated <code>ValidationErrorResponse</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ValidationErrorResponse();

        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient.default.convertToType(data['message'], 'String');
        }

        if (data.hasOwnProperty('errors')) {
          obj['errors'] = _ApiClient.default.convertToType(data['errors'], [_ValidationError.default]);
        }
      }

      return obj;
    }
  }]);

  return ValidationErrorResponse;
}();
/**
 * @member {String} message
 */


ValidationErrorResponse.prototype['message'] = undefined;
/**
 * @member {Array.<module:model/ValidationError>} errors
 */

ValidationErrorResponse.prototype['errors'] = undefined;
var _default = ValidationErrorResponse;
exports.default = _default;